<template>
<div>
<!-- SESSION_LIFETIME=120 -->
    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-user-shield"></i><span> Usuarios</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('usuario.crear')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                            </template>

                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getListUsuarios(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div>
                                        <el-input @keyup.enter.native="getListUsuarios(1,pag_mostrar)" placeholder="Texto a buscar" v-model="cBusqueda" class="input-with-select" clearable>
                                            <el-select v-model="cCriterio" slot="prepend" placeholder="Select">
                                            <el-option value="nombre" label="Nombre"></el-option>
                                            <el-option value="username" label="Usuario"></el-option>
                                            <el-option value="email" label="Email"></el-option>
                                            <el-option value="numdoc" label="N° Documento"></el-option>
                                            <el-option value="state" label="Estado"></el-option>
                                            </el-select> <i class="fas fa-search"></i>
                                            <el-button class="button-library-group" slot="append" icon="fas fa-search" @click.prevent="getListUsuarios(1,pag_mostrar)"></el-button>
                                        </el-input>
                                    </div>
                                </div>

                            </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Acciones</b></th>
                                            <th><b>Fotografia</b></th>
                                            <th><b>Nombre</b></th>
                                            <th><b>Usuario</b></th>
                                            <th><b>Correo</b></th>
                                            <th><b>Rol</b></th>
                                            <th><b>Estado</b></th>
                                            <th><b>Documento</b></th>
                                            <th><b>Telefono</b></th>
                                            <th><b>N° Documento</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listUsuarios.length">
                                        <tr v-for="(u, index) in listUsuarios" :key="index">
                                             <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">
                                                       <!--  <button class="dropdown-item" v-if="u.state_alias=='ACTIVO'" @click="setObtenerUser(u.id)"><i class="far fa-eye" ></i> Ver</button> -->
                                                        <template  v-if="AsignarRolPermisosByUsuario.includes('usuario.editar')">
                                                            <button class="dropdown-item" v-if="u.state_alias=='ACTIVO'"  @click="setObtenerUser(u.id)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        </template>
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('usuario.eliminar')">
                                                            <button class="dropdown-item" v-if="u.state_alias=='INACTIVO'" @click="tranferirUsuario(u.id,u.file)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>
                                                        </template>

                                                        <button class="dropdown-item" v-if="u.state_alias=='ACTIVO'" @click="getPermisosRoles(u.idrol,u.id)"><i class="fas fa-key text-warning" ></i> Permisos</button>

                                                        <template v-if="AsignarRolPermisosByUsuario.includes('usuario.desactivar')">
                                                            <button class="dropdown-item" v-if="u.state_alias=='ACTIVO'"  @click="setEstadoUser(1,u.id)"><i class="fas fa-trash text-danger" ></i> Desactivar</button>
                                                        </template>
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('usuario.activar')">
                                                            <button class="dropdown-item" v-if="u.state_alias=='INACTIVO'"  @click="setEstadoUser(2,u.id)"><i class="fas fa-check text-success" ></i>  Activar</button>
                                                        </template>
                                                    </div>
                                                </div>
                                            </td>
                                            <td  class="center-img">

                                                <template v-if="!u.file">
                                                    <img src="img/noimageuser.png" :alt="u.username" class="chat-img" >
                                                </template>
                                                <template v-else>
                                                    <img v-bind:src="'storage/users/'+u.file" :alt="u.username" class="chat-img" >
                                                </template>

                                            </td>
                                            <td v-text="u.fullname"></td>
                                            <td v-text="u.username"></td>
                                            <td v-text="u.email"></td>
                                            <td v-text="u.rol"></td>
                                            <td>
                                                <span class="u-label bg-success text-white" v-if="u.state_alias=='ACTIVO'" >Activo</span>
                                                <span class="u-label bg-danger text-white" v-else>Inactivo</span>
                                            </td>
                                            <td v-text="u.tipo_doc"></td>
                                            <td v-text="u.telefono"></td>
                                            <td v-text="u.numdoc"></td>
                                           
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Usuario-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar Usuario</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <form id="for-user">
                            <div class="row row-cols-sm-1 row-cols-md-1 row-cols-lg-1">

                                 <div class="col-md-12 col-lg-5  col-xl-3"  align="center" >
                                    <label for="text-input"> <b>Fotografia de Usuario</b> </label>
                                     <div class="kv-avatar">
                                        <input vue-load-image   type="file" name="img" @change="obtenerImagen"  id="imgUser" accept="image/*">
                                     </div>
                                </div>
                                <div class="col-md-12 col-lg-7 col-xl-9">

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="nombres">Nombres</label>
                                                <input type="text" class="form-control" id="nombres" v-model="vaCreUser.cNombre" placeholder="Ingrese nombres completos">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="apellidos">Apellidos</label>
                                                <input type="text" class="form-control" id="apellidos"  v-model="vaCreUser.cApellido" placeholder="Ingrese apellidos Completos">
                                            </div>
                                        </div>
                                         <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="usuarios">Usuario</label>
                                                <input type="text" class="form-control" id="usuarios" v-model="vaCreUser.cUsuario" placeholder="Ingrese un nombre de usuario">
                                            </div>
                                        </div>
                                    
                                    
                                       
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="email">Correo</label>
                                                <input type="email" class="form-control" id="email" v-model="vaCreUser.cCorreo" placeholder="Ingrese un correo electronico">
                                            </div>
                                        </div>
                                   

                                    
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="usuarios">Contraseña</label>
                                                <input type="password" class="form-control"   v-model="vaCreUser.cContrasena" placeholder="Ingrese una contraseña">

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="status-select" class="mr-2">Documento</label>
                                                <select class="custom-select" v-model="vaCreUser.eIdDocumento" id="status-select">
                                                    <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                                </select>

                                            </div>
                                        </div>
                                    

                                    
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="usuarios">N° Documento</label>
                                                <input type="text" class="form-control" v-model="vaCreUser.cNumDoc" placeholder="Ingrese numero de documento">
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="status-estado" class="mr-2">Estado</label>
                                                <select class="custom-select" v-model="vaCreUser.cState" id="status-estado">
                                                    <option value="A">Activo</option>
                                                    <option value="I">Inactivo</option>
                                                </select>

                                            </div>
                                        </div>
                                    
                                    
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="telefono">Telefono</label>
                                                <input type="text" class="form-control" v-model="vaCreUser.telefono" placeholder="Ingrese numero de telefono">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="rol" class="mr-2">Rol</label>
                                                <select class="custom-select" v-model="vaCreUser.idRol" id="rol">
                                                    <option value="0">Selecione un Rol</option>
                                                    <option v-for="rol in aTipoRol" :key="rol.id" :value="rol.id" v-text="rol.name"></option>
                                                </select>

                                            </div>
                                        </div>
                                    
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="email">Correo de envio</label>
                                                <input type="email" class="form-control" id="email_envio" v-model="vaCreUser.envio_email" placeholder="Ingrese un correo electronico">
                                            </div>
                                        </div>
                                     
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="usuarios">Contraseña envio correo</label>
                                                <input type="password" class="form-control"   v-model="vaCreUser.envio_password" placeholder="Ingrese una contraseña">

                                            </div>
                                        </div>
                                        

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="LeadName">Fecha Nacimiento </label>
                                                <input type="date" class="form-control" v-model="vaCreUser.fecha_nacimiento" >
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="clasificacion" class="mr-2">Clasificación</label>
                                                <select class="custom-select" v-model="vaCreUser.clasificacion" id="clasificacion">
                                                    <option value="1">Merbrok</option>
                                                    <option value="2">Asociados</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-4" v-if="vaCreUser.clasificacion == 2" >
                                            <div class="form-group">
                                                <label for="comision" class="mr-2">Comisión Asociados</label>
                                                <select class="custom-select" v-model="vaCreUser.comision" id="comision">
                                                    <option  v-for="item in 20" :key="item" :value="item" v-text="item + '%'"></option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>  
                                   

                                </div>

                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary" @click="setRegistrarUser" v-text="nameButon">Guardar</button>
                            <button type="button" v-if="actu_reg==1" class="btn btn-sm btn-primary" @click="setActualizarUser" v-text="nameButon">Actualizar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Usuario-------------------------------------------------------------->


        <!--   Inicio modal Permisos Rol-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow2 }" :style=" modalShow2 ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar rol con sus permisos</h5>
                        <button type="button" @click="cerrarModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row row-cols-sm-1 row-cols-md-1 row-cols-lg-1">
                            <div class="col-md-12 col-lg-5 col-sm-12">
                                <div class="card">
                                    <div class="card-header bg-info color-text-p">Listar Permisos del Rol</div>
                                    <div class="card-body">
                                        <div class="scrollTable">
                                            <table class="table">
                                                <thead>
                                                    <tr>

                                                        <th>Nombre</th>
                                                        <th>Url Amigable</th>

                                                    </tr>
                                                </thead>
                                                <tbody v-if="listPermisosRol.length">
                                                    <tr v-for="(item, index) in listPermisosRol" :key="index">
                                                        <td v-text="item.name">1</td>
                                                        <td v-text="item.slug">1</td>
                                                    </tr>

                                                </tbody>
                                                <tbody v-else>
                                                <tr>
                                                    <td colspan="2" align="center">
                                                        <h5>No se encontraron resultados...</h5>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-7 col-sm-12">
                                <div class="card">
                                    <div class="card-header bg-info color-text-p"> Lista de Permisos</div>
                                    <div class="card-body">
                                        <div class="row">
                                                <div class="col-md-5">

                                                    <div class="input-group" style="padding-bottom: 10px;">
                                                        <span class="input-group-btn">
                                                            <button type="button" class="btn waves-effect waves-light btn-primary"  @click="seleccionarTodo()">
                                                                <i :class="(selectDeselectAll == true) ? 'far fa-check-square fa-lg': 'far fa-square fa-lg'"></i>
                                                            </button>
                                                        </span>
                                                        <label for="" class="form-control">Seleccionar todo</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-7">
                                                    <div class="input-group" style="padding-bottom: 10px;">
                                                        <span class="input-group-btn">
                                                            <button type="button"
                                                                class="btn waves-effect waves-light btn-primary">
                                                                <i class="fa fa-search"></i>
                                                            </button>
                                                        </span>
                                                        <input type="text" class="form-control" v-model="buscarNombre"  placeholder="Buscar..." />
                                                        <span class="input-group-btn">
                                                            <button type="button" class="btn waves-effect waves-light btn-primary" @click="buscarNombre=''">
                                                                <i class="far fa-times-circle"></i>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="scrollTable">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th >Seleccionar</th>
                                                        <th>Nombre</th>
                                                        <th>Url Amigable</th>

                                                    </tr>
                                                </thead>
                                                <tbody v-if="listPermisosFilter.length">
                                                    <tr v-for="(item, index) in filtroListaPermisos" :key="index" @click.prevent="marcarFila(index)">
                                                        <td >
                                                            <div class="checkbox checkbox-primary d-inline">
                                                                <input @click="selectDeselectAll=false" type="checkbox" name="checkbox-p-1" id="checkbox-p-1" v-model="item.checked">
                                                                <label for="checkbox-p-1" class="cr"></label>
                                                            </div>
                                                        </td>
                                                        <td v-text="item.name">1</td>
                                                        <td v-text="item.slug">1</td>
                                                    </tr>

                                                </tbody>
                                                <tbody v-else>
                                                <tr>
                                                    <td colspan="3" align="center">
                                                        <h5>No se encontraron resultados...</h5>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="modal-footer" >
                            <button type="button"  class="btn btn-sm btn-primary" @click="setRegistrarPermisosByUsuario()"  v-text="nameButon">Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="cerrarModal">Cerrar</button>
                     </div>


                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Permisos Rol-------------------------------------------------------------->

        <!-- modal transferir data  -->

        <div class="modal fade " :class="{ show: modal_show_delete }" :style=" modal_show_delete ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" >Eliminar Usuario</h5>
                        <button type="button" @click="tranferirUsuario(0,'')" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <p>Elija un usuario a transferir la data del usuario a eliminar</p>  
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="LeadName">Usuario</label>
                                        <select v-model="user_eliminar.user_tranferir_id"  class="custom-select" >
                                            <option value="0">Selecionar</option>
                                            <option v-for="u in user_all" :key="u.id" :value="u.id" v-text="u.fullname"></option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="usuarios">Ingrese su contraseña</label>
                                        <input type="password" class="form-control"   v-model="user_eliminar.password" placeholder="Contraseña">

                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" class="btn btn-sm btn-danger" @click="eliminarUsuario()">Eliminar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="tranferirUsuario(0,'')">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {
    props: ['ruta'],
    data() {
        return {
            cCriterio: 'nombre',
            cBusqueda: '',
            listUsuarios: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,
            modalShow2: false,
            modal_show_delete: false,
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            vaCreUser:{
                eId: 0,
                cNombre: '',
                cApellido: '',
                cUsuario: '',
                cCorreo: '',
                cContrasena: '',
                cFotografia: '',
                cNumDoc: '',
                telefono: '',
                cState: 'A',
                eIdDocumento: 1,
                idRol: 0,
                envio_password: '',
                fecha_nacimiento: '',
                envio_email: '',
                clasificacion: 1,
                comision: 1
            },
            form: new FormData,
            aTipoDocumento: [],
            aTipoRol: [],
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            listRol: [],
            listPermisosFilter: [],
            listPermisosRol: [],
            listPermisos: [],
            idUserPermisos: 0,
            listRolPermisosByUsuario: [],
            listRolPermisosByUsuarioFilter: [],
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            selectDeselectAll: false,
            buscarNombre: '',
            user_eliminar: {

                id                  : 0,    //Usuario a eliminar
                imagen              : null,     
                password            : null, //Usuario admin del sistema
                user_tranferir_id   : 0,

            },
            user_all: [],
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "$ ",
                suffix: "",
                precision: 2,
                masked: false,
            },

        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;

                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;

                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },

            filtroListaPermisos(){

            return this.listPermisosFilter.filter(user => {
                return user.name.toLowerCase().includes(this.buscarNombre.toLowerCase())
            });
        }
        },
    methods: {

        //Listamos Usuarios
        getListUsuarios(page,pag_mostrar){

          var url = '/administracion/usuario/getListarUsuarios';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'cCriterio': this.cCriterio,
                  'cBusqueda': this.cBusqueda,
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {
                var respuesta = res.data;
                this.listUsuarios   = respuesta.user.data;
                this.user_all       = respuesta.all_user;
                this.pagination     = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
              if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
              this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })

        },
        //Cambiar pagina
        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getListUsuarios(page,me.pag_mostrar);
        },
        //Abrir modal 1
        abrirModal() {
            this.modalShow = !this.modalShow;
            this.imagenId();
            if(this.modalShow==true){
                this.getSelectTipoDoc();
                this.listarRol();
                this.tituloModal = "Registrar Usuarios";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{
                this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },
        //Cerrar modal2 de los permisos
        cerrarModal(){
             this.modalShow2 = !this.modalShow2;

            if(!this.modalShow==true){
                this.listPermisosRol = [];
                this.listPermisosFilter = [];
                this.listPermisos = [];
                this.idUserPermisos = 0;
            }
        },
        //Trae los tipos de documentos para un select
        getSelectTipoDoc(){

            var url = '/administracion/usuario/getListarDocumentos';

            axios.get(url)
            .then(res => {

                var respuesta = res.data;
                this.aTipoDocumento = respuesta.documento;
                //console.log(respuesta.documento);

            })
            .catch(err => {

                console.error(err);
                 if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
            })
        },
        //Obtenemos los datos al seleccionar una imagen
        obtenerImagen(e){
                let file =  e.target.files[0]
                this.vaCreUser.cFotografia = file

                //console.log(e);
        },
        //Limpiamos el form o las variables
        cleanVariables(){
            this.vaCreUser.cNombre = "";
            this.vaCreUser.cApellido  = "";
            this.vaCreUser.cUsuario = "";
            this.vaCreUser.cCorreo = "";
            this.vaCreUser.cContrasena = "";
            this.vaCreUser.cFotografia = "";
            this.vaCreUser.cNumDoc = "";
            this.vaCreUser.telefono = "";
            this.vaCreUser.cState = "A"
            this.vaCreUser.eIdDocumento = 1;
            this.vaCreUser.eId = 0;
            this.vaCreUser.envio_email = "";
            this.vaCreUser.envio_password = "";
            this.vaCreUser.fecha_nacimiento = null;
            this.vaCreUser.clasificacion = 1;
            this.vaCreUser.comision = 1;
            this.form = new FormData;
            $("#for-user")[0].reset();//Reset
        },
        //Registramos al usuario
        setRegistrarUser(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/administracion/usuario/registrar';

            this.form.append('Nombre', this.vaCreUser.cNombre);
            this.form.append('Apellido', this.vaCreUser.cApellido);
            this.form.append('Usuario', this.vaCreUser.cUsuario);
            this.form.append('Correo', this.vaCreUser.cCorreo);
            this.form.append('cContrasena', this.vaCreUser.cContrasena);
            this.form.append('cFotografia', this.vaCreUser.cFotografia);
            this.form.append('cNumDoc', this.vaCreUser.cNumDoc);
            this.form.append('telefono', this.vaCreUser.telefono);
            this.form.append('cState', this.vaCreUser.cState);
            this.form.append('eIdDocumento', this.vaCreUser.eIdDocumento);
            this.form.append('idRol', this.vaCreUser.idRol);
            this.form.append('envio_email', this.vaCreUser.envio_email);
            this.form.append('envio_password', this.vaCreUser.envio_password);
            this.form.append('fecha_nacimiento', this.vaCreUser.fecha_nacimiento);
            this.form.append('clasificacion', this.vaCreUser.clasificacion);
            this.form.append('comision', (this.vaCreUser.clasificacion == 2) ? this.vaCreUser.comision : 0);

            const config = { headers: { 'Content-Type': 'multipart/form-data'}}//Aceptamos archivos

            axios.post(url, this.form, config).then(res => {


                if(res.data.status){

                this.notify(" Usuario registrado con éxito","","top","center","fas fa-user-check","success",' flipInX','flipOutX');
                    
                this.cleanVariables();//Limpiamos el form
                //this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.getListUsuarios(1,this.pag_mostrar);
                this.modalShow=false;
                this.getRefrescarUsuarioAutenticado();

               }else{

                    this.notify(" Error al registrar usuario","","top","center","fas fa-user-times","danger",' flipInX','flipOutX')

                }
                

            })
            .catch(err => {
                console.error(err);

                if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }

                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                    this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
                console.error(err);
            })
        },
        //Obtenemos los datos del usuario y los asignamos a las variables, luego abrimos modal
        setObtenerUser(id){

            var url = '/administracion/usuario/obteneruser';
            this.openCargando();//Activamos ventana de carga de bloqueo
            this.tituloModal = "Actualizar Usuarios";
            this.nameButon = "Actualizar"
            this.getSelectTipoDoc();
            this.listarRol();
            this.imagenId();

            axios.get(url,{params:{'id': id}})
            .then(res => {
                //this.imagenId();
                var respuesta = res.data.user[0];
                this.vaCreUser.eId                  = respuesta.id;
                this.vaCreUser.cNombre              = respuesta.firstname;
                this.vaCreUser.cApellido            = respuesta.lastname;
                this.vaCreUser.cUsuario             = respuesta.username;
                this.vaCreUser.cCorreo              = respuesta.email;
                this.vaCreUser.cFotografia          = respuesta.file;
                this.vaCreUser.cNumDoc              = respuesta.numdoc;
                this.vaCreUser.telefono             = respuesta.telefono;
                this.vaCreUser.cState               = respuesta.state;
                this.vaCreUser.eIdDocumento         = respuesta.iddocumento;
                this.vaCreUser.envio_email          = respuesta.envio_correo;
                
                this.vaCreUser.fecha_nacimiento     = respuesta.fecha_nacimiento;
                this.vaCreUser.clasificacion        = respuesta.clasificacion;
                this.vaCreUser.comision             = respuesta.comision;
                this.vaCreUser.idRol                = res.data.rol[0].role_id;

                if(this.vaCreUser.cFotografia){
                  document.getElementById("cimg").src = "storage/users/"+ this.vaCreUser.cFotografia;
                }else{
                   document.getElementById("cimg").src = "img/noimageuser.png";
                }
                this.modalShow = true;
                this.actu_reg = 1;

                this.openCargando(true);//Desactivamos ventana de carga de bloqueo


            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.actu_reg = 0;
                console.error(err);
                if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                }

            })
        },
        //Actualizamos al usuario
        setActualizarUser(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/administracion/usuario/actualizar';

            this.form.append('id', this.vaCreUser.eId);
            this.form.append('Nombre', this.vaCreUser.cNombre);
            this.form.append('Apellido', this.vaCreUser.cApellido);
            this.form.append('Usuario', this.vaCreUser.cUsuario);
            this.form.append('Correo', this.vaCreUser.cCorreo);
            this.form.append('cContrasena', this.vaCreUser.cContrasena);
            this.form.append('cFotografia', this.vaCreUser.cFotografia);
            this.form.append('cNumDoc', this.vaCreUser.cNumDoc);
            this.form.append('telefono', this.vaCreUser.telefono);
            this.form.append('cState', this.vaCreUser.cState);
            this.form.append('eIdDocumento', this.vaCreUser.eIdDocumento);
            this.form.append('idRol', this.vaCreUser.idRol);
            this.form.append('envio_email', this.vaCreUser.envio_email);
            this.form.append('envio_password', this.vaCreUser.envio_password);
            this.form.append('fecha_nacimiento', this.vaCreUser.fecha_nacimiento);
             this.form.append('clasificacion', this.vaCreUser.clasificacion);
            this.form.append('comision', (this.vaCreUser.clasificacion == 2) ? this.vaCreUser.comision : 0);

            const config = { headers: { 'Content-Type': 'multipart/form-data'}}//Aceptamos archivos

            axios.post(url, this.form, config).then(res => {


                
                //this.openCargando(true);
                if(res.data.status){

                    this.notify(" Usuario actualizado con éxito","","top","center","fas fa-user-check","success",' flipInX','flipOutX')
                    this.cleanVariables();//Limpiamos el form
                    this.getListUsuarios(1,this.pag_mostrar);
                    this.modalShow=false;
                    this.getRefrescarUsuarioAutenticado();
                }else{

                    this.notify(" Error al actualizar usuario","","top","center","fas fa-user-times","danger",' flipInX','flipOutX')

                }

                this.openCargando(true);

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                }
                console.error(err);
            })
        },
        //Actualizamos el estado del usuario
        setEstadoUser(op, id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de ' + ((op == 1) ? 'desactivar' : 'activar') + ' el usuario?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: ((op == 1) ? 'Si, desactivar' : 'Si, activar'),
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){

                        var url = '/administracion/usuario/estado';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                            'estado' : (op == 1) ? 'I' : 'A'
                        })
                        .then(res => {
                             this.openCargando(true);
                            if(res.data.status){
                             this.notify(' Se ' + ((op == 1) ? 'desactivo' : 'activo') + ' el usuario',"","top","center",((op == 1) ? 'fas fa-user-times' : 'fas fa-user-check'),'success',' flipInX','flipOutX')
                            }
                            this.getListUsuarios(1,this.pag_mostrar);
                        })
                        .catch(err => {
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                            console.error(err);
                        })
                }
            })
        },
        //Listamos los roles para un select
        listarRol(){

          var url = '/administracion/rol/listarRol';

          axios.get(url)
          .then(res => {

            this.aTipoRol = res.data;

          })
          .catch(err => {
              if (err.response.status == 401) {
                    this.$router.push({name: 'login'})
                    location.reload();
                    localStorage.clear();
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
              }
              console.error(err);

          })

        },
        //Traemos los datos del usuario autenticado y los emitimos
        getRefrescarUsuarioAutenticado() {
                var url = '/authenticate/getRefrescarUsuarioAutenticado'
                axios.get(url).then(response => {

                    EventBus.$emit('verifyAuthenticatedUser', response.data);
                   // this.getUsuarioById();
                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo

                    }
                     this.openCargando(true);
                })
        },

        //Listamos los permisos del rol y usuario
        getPermisosRoles(idrol,idUser){

            var url = '/administracion/rol/lispermisorol';
            this.openCargando();//Activamos ventana de carga de bloqueo
            this.tituloModal = "Asignar Permisos";
            this.nameButon = "Guardar";
            this.idUserPermisos = idUser;


            axios.get(url,{params:{'id': idrol,'iduser': idUser}})
            .then(res => {
                let me = this;

                me.listPermisosRol  = res.data.permisorol;
                me.listPermisos = res.data.permisouser;
                this.filterPermisosByUsuario();

                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                //this.filterPermisosByRol();
                this.modalShow2 = true;

            })
            .catch(err => {
                if (err.response.status == 401) {
                    this.$router.push({name: 'login'})
                    location.reload();
                    localStorage.clear();
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
              }
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                console.error(err);

            })
        },
        //Filtramos los permisos asignados y los marca check
        filterPermisosByUsuario() {
                let me = this;
                me.listPermisos.map(function(x, y){
                    me.listPermisosFilter.push({
                        'id'        :   x.id,
                        'name'      :   x.name,
                        'slug'      :   x.slug,
                        'checked'   :   (x.checked == 1) ? true : false
                    })
                })
        },
        //Marca check en la tabla
        marcarFila(index){

            this.listPermisosFilter[index].checked  =   !this.listPermisosFilter[index].checked;

        },
        //Validamos que almenos seleccione un permiso de usuarios
        validarRegistroPermisosUser(){
             let contador = 0;
                this.listPermisosFilter.map(function(x, y){
                    if (x.checked == true) {
                        contador++;
                    }
                })
                if (contador == 0) {
                    this.notify(" Debe seleccionar al menos un permiso","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                    return true;
                }

            return false;
        },
        //Registramos permisos del usuario
        setRegistrarPermisosByUsuario(){

             if (this.validarRegistroPermisosUser()) {
                 return;
             }
            this.openCargando();
            var url = '/administracion/usuario/registrarpermisosuser'
                axios.post(url, {
                    'id'                :   this.idUserPermisos,
                    'listPermisosFilter':   this.listPermisosFilter
                }).then(response => {

                  this.getListarRolPermisosByUsuario();

                   if(response.data.status){

                        this.notify(" Se otorgaron los permisos al usuario correctamente","","top","center","fas fa-key","success",' flipInX','flipOutX')

                   }else{

                        this.notify(" Error otorgaron los permisos al usuario","","top","center","fas fa-key","error",' flipInX','flipOutX')

                   }

                }).catch(error => {
                   if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    this.openCargando(true);

                })

        },

        getListarRolPermisosByUsuario(){
                var ruta = '/administracion/usuario/getListarRolPermisosByUsuario'
                axios.get(ruta).then( response => {

                    this.listRolPermisosByUsuario = response.data;//Guardamos la data en un array
                    this.filterListarRolPermisosByUsuario();

                }).catch(error => {

                    console.errorerror
                    if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                })
        },
        //Filtramos y solo guardamos la url amigable
        filterListarRolPermisosByUsuario() {
                let me = this;
                me.listRolPermisosByUsuarioFilter = [];

                me.listRolPermisosByUsuario.map(function(x, y){
                    me.listRolPermisosByUsuarioFilter.push(x.slug)
                })
                localStorage.setItem('listRolPermisosByUsuario', JSON.stringify(me.listRolPermisosByUsuarioFilter));
                EventBus.$emit('notifyRolPermisosByUsuario', me.listRolPermisosByUsuarioFilter);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.cerrarModal();
        },
        imagenId(){
            
            this.$nextTick(()=>{
                 $('#imgUser').fileinput({
                    language: 'es',
                    allowedFileExtensions:['jpeg','jpg','png'],
                    maxFileSize: 8000,//8mb
                    showUpload:false,
                    showClose: false,
                    dropZoneEnabled: false,
                    browseLabel: '',
                    removeLabel: '',
                    browseIcon: '<i class="fas fa-folder-open"></i>',
                    removeIcon: '<i class="fas fa-trash-alt"></i>',
                    overwriteInitial: true,showCaption: false,
                    /*
                    showRemove: true,

                    initialPreviewAsData:true,
                    */
                    theme: "fa",
                    defaultPreviewContent:'<img id="cimg" class="center img-thumbnail" src="img/noimageuser.png">',
                });
            });
        },

        tranferirUsuario(user_id,imagen){

            this.modal_show_delete = !this.modal_show_delete
            if(this.modal_show_delete){

                this.user_eliminar.id                  = user_id;
                this.user_eliminar.imagen              = imagen;
                this.user_eliminar.password            = null;
                this.user_eliminar.user_tranferir_id   = 0;

            }else{

                this.user_eliminar.id                  = 0;
                this.user_eliminar.imagen              = null;
                this.user_eliminar.password            = null;
                this.user_eliminar.user_tranferir_id   = 0;
            }
        },

        eliminarUsuario(){
            let me = this;

            if(me.user_eliminar.user_tranferir_id == 0 || me.user_eliminar.password == ''){
                this.notify(" Complete los datos solicitados","","top","center","fas fa-user-check","danger",' flipInX','flipOutX')
                return
            }

            me.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el usuario?',
                //text: "You won't be able to revert this!",
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){

                        var url = '/administracion/usuario/eliminar';
                        me.openCargando();

                        axios.post(url,{
                            'id'            : me.user_eliminar.id,
                            'imagen'        : me.user_eliminar.imagen,
                            'user_tranferir' : me.user_eliminar.user_tranferir_id,
                            'password'      : me.user_eliminar.password,
                        })
                        .then(res => {

                            me.openCargando(true);
                            if(res.data.status){
                                
                                me.notify(" Usuario eliminado con éxito","","top","center","fas fa-user-check","success",' flipInX','flipOutX')
                                me.tranferirUsuario(0,'');
                                me.getListUsuarios(1,me.pag_mostrar);

                            }else{
                                me.notify(res.data.mensaje,"","top","center","fas fa-user-check","danger",' flipInX','flipOutX')
                            }
                            
                        })
                        .catch(err => {
                            this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                             console.error(err);
                                if (err.response.status == 401) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                }
                                
                            })
                    }
                }
            )
        },

        seleccionarTodo(){
            for (let index = 0; index < this.listPermisosFilter.length; index++) {
                this.listPermisosFilter[index].checked = !this.selectDeselectAll;
            }
            this.selectDeselectAll =!this.selectDeselectAll;
        },




    },
    mounted() {

            this.getListUsuarios(1,this.pag_mostrar);
            


    },
}
</script>

<style>
</style>
